import { h, Host } from "@stencil/core";
import { TABULAR_GRID_PARTS_DICTIONARY } from "../../../common/reserved-names";
import { tokenMap } from "../../../common/utils";
/**
 * The `ch-tabular-grid-columnset` component represents a group of columns.
 */
export class ChTabularGridColumnset {
    constructor() {
        this.parts = undefined;
    }
    el;
    columnSortChangedHandler(eventInfo) {
        const columns = Array.from(this.el.querySelectorAll("ch-tabular-grid-column"));
        columns.forEach(column => {
            if (column.columnId !== eventInfo.detail.columnId) {
                column.sortDirection = null;
            }
        });
    }
    render() {
        return (h(Host, { key: '2ec6c52af0825603c03e8d4477ec5439727a3a53', part: this.parts
                ? tokenMap({
                    [TABULAR_GRID_PARTS_DICTIONARY.COLUMNSET]: true,
                    [this.parts.toString()]: typeof this.parts === "string"
                })
                : null }));
    }
    static get is() { return "ch-tabular-grid-columnset"; }
    static get originalStyleUrls() {
        return {
            "$": ["tabular-grid-columnset.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["tabular-grid-columnset.css"]
        };
    }
    static get properties() {
        return {
            "parts": {
                "type": "any",
                "mutable": false,
                "complexType": {
                    "original": "boolean | string",
                    "resolved": "boolean | string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "A boolean or string that controls the parts applied to the column.\n- When `true`, it automatically applies the part names \"column\" and the column's unique ID.\n- When a string is provided, it appends that string to the default part names \"column\" and the column's ID."
                },
                "attribute": "parts",
                "reflect": false
            }
        };
    }
    static get elementRef() { return "el"; }
    static get listeners() {
        return [{
                "name": "columnSortChanged",
                "method": "columnSortChangedHandler",
                "target": undefined,
                "capture": false,
                "passive": false
            }];
    }
}
